import React, { useEffect, useState, useContext } from "react";
import {
  ColorPicker,
  IconSelectedContainer,
  ContainerButtons,
  LowerWrapper,
  ContainerIteration,
  GeneralStyle,
  EditSection,
  UpperWrapper,
  VSection,
  QuestionWrapper,
  SelectsSection,
  ContainerTitle,
  EditButton,
  DeleteButton,
  CloneButton,
  SaveToBank,
  TooltipCheckSection,
  TooltipDescriptionContainer,
} from "./ImageRatingBox.styled";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import MessageYesNo from "../MessageYesNo/index";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import {
  FormControlLabel,
  Checkbox,
  Box,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import ModalSaveToBank from "../ModalSaveToBank";
import InfoIcon from "@material-ui/icons/Info";
import { theme as themeConfig } from "../../themes/themes";

const ImageComponent = ({
  elementKey,
  colorPicker,
  setQualification,
  selectImage,
}) => {
  switch (selectImage) {
    case "star":
      return (
        <StarRoundedIcon
          key={elementKey}
          className="icon-selected-preview"
          onClick={() => setQualification(elementKey)}
          style={{ fill: colorPicker }}
        ></StarRoundedIcon>
      );
    case "heart":
      return (
        <FavoriteRoundedIcon
          key={elementKey}
          className="icon-selected-preview"
          onClick={() => setQualification(elementKey)}
          style={{ fill: colorPicker }}
        ></FavoriteRoundedIcon>
      );
    default:
      return (
        <div>
          <div className="radio-survey">
            <input
              type="radio"
              value={elementKey}
              name="number"
              onClick={() => setQualification(elementKey)}
            />{" "}
            {elementKey}
          </div>
        </div>
      );
  }
};
const ImageRatingBox = ({
  title,
  setTitle,
  setQualification,
  colorPicker,
  setColorPicker,
  selectImage,
  setSelectImage,
  mandatory,
  setMandatory,
  editable,
  loadCategories,
  chooiseSelectImage,
  setRefTitle,
  refIsMandatory,
  setRefIsMandatory,
  refValidationText,
  setRefValidationText,
  refCategory,
  setRefCategory,
  saveQuestionBank,
  handleEdit,
  handleCancel,
  refCantImage,
  setCantImage,
  setCategoryAnswer,
  configQuestionStyle,
  setconfigQuestionStyle,
  handleDeleteQuestion,
  idQuestionSurvey,
  globalProps,
  categories,
  identity,
  saveFormQuestion,
  tooltipInformationCheck,
  tooltipDescriptionText,
  setShowTooltipDescription,
  handleTextAreaText,
  changeTooltipInformationCheck,
  showTooltipDescription,
}) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);

  const [imagePreview, setImagePreview] = useState([
    <ImageComponent
      key={1}
      elementKey={1}
      colorPicker={colorPicker}
      setQualification={setQualification}
      selectImage={selectImage}
    />,
    <ImageComponent
      key={2}
      elementKey={2}
      colorPicker={colorPicker}
      setQualification={setQualification}
      selectImage={selectImage}
    />,
  ]);

  const [colorBackground] = useState("#f9f9f9");
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);
  // let [childDependencies, setchildDependencies] = useState(0)
  //   useEffect(() => {
  //     if (globalProps.GidParentQuestion != 0) {
  //       let flagParent = globalProps.GidParentQuestion
  //       while (flagParent > 0) {
  //         let position = stateQuestionsReducer.questions.findIndex(i => i.GidQuestionSurvey == flagParent)
  //         if (position >= 0) {
  //           flagParent = stateQuestionsReducer.questions[position].GidParentQuestion
  //           childDependencies++
  //         }
  //         else {
  //           flagParent = 0
  //         }
  //       }
  //       setchildDependencies(childDependencies)
  //     }
  //   }, [])

  useEffect(() => {
    handSectionSubpanel(refCantImage, colorPicker);
  }, [colorPicker, refCantImage, selectImage]);

  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };

  let handleTitleInput = (e) => {
    setTitle(e.target.value);
    setRefTitle(e.target.value);
  };
  let handleColorPicker = (e) => {
    setColorPicker(e.target.value);
  };
  let handleChoiseIcon = (e) => {
    setSelectImage(e.target.value);
    switch (e.target.value) {
      case "star":
        setCategoryAnswer(1);
        break;
      case "heart":
        setCategoryAnswer(1);
        break;
      case "numbers":
        setCategoryAnswer(6);
        break;
      default:
        setCategoryAnswer(1);
    }
  };
  let handleMandatory = (e) => {
    setMandatory(e.target.checked);
    setRefIsMandatory(e.target.checked);
  };
  let handleValidationtext = (e) => {
    setRefValidationText(e.target.value);
  };
  let handleRefCategory = (e) => {
    setRefCategory(e.target.value);
  };
  let handSectionSubpanel = (numberKey, colorPicker) => {
    setCantImage(parseInt(numberKey));
    switch (parseInt(numberKey)) {
      case 2:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 3:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 4:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 5:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 6:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={6}
            elementKey={6}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 7:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={6}
            elementKey={6}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={7}
            elementKey={7}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 8:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={6}
            elementKey={6}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={7}
            elementKey={7}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={8}
            elementKey={8}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 9:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={6}
            elementKey={6}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={7}
            elementKey={7}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={8}
            elementKey={8}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={9}
            elementKey={9}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      case 10:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={3}
            elementKey={3}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={4}
            elementKey={4}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={5}
            elementKey={5}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={6}
            elementKey={6}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={7}
            elementKey={7}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={8}
            elementKey={8}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={9}
            elementKey={9}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={10}
            elementKey={10}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
      default:
        setImagePreview([
          <ImageComponent
            key={1}
            elementKey={1}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
          <ImageComponent
            key={2}
            elementKey={2}
            colorPicker={colorPicker}
            setQualification={setQualification}
            selectImage={selectImage}
          />,
        ]);
        break;
    }
  };
  return (
    <GeneralStyle
      // childDependencies={((childDependencies/10)*16777215).toString(16)}
      isDependent={globalProps.GisDependent}
      editable={editable}
      colorBackground={
        configQuestionStyle.customStyle
          ? configQuestionStyle.background
          : colorBackground
      }
    >
      {editable ? (
        <EditSection>
          <VSection>
            <FormControlLabel
              control={
                <Checkbox
                  checked={refIsMandatory}
                  onChange={(e) => handleMandatory(e)}
                  name="mandatory-check"
                />
              }
              label="Mandatory Question"
            />
            {mandatory ? (
              <input
                onChange={(e) => handleValidationtext(e)}
                type="text"
                placeholder="Enter mandatory message here"
                id="mText"
                defaultValue={refValidationText}
              ></input>
            ) : null}
          </VSection>
          <hr />
          <UpperWrapper>
            <QuestionWrapper>
              <label>Question:</label>
              <textarea
                onChange={(e) => handleTitleInput(e)}
                type="text"
                placeholder="Enter your question here"
                defaultValue={title}
              ></textarea>
            </QuestionWrapper>
            {identity !== "form" && (
              <>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <SelectsSection>
                      <div>
                        <label>Category</label>
                        <select
                          onChange={(e) => handleRefCategory(e)}
                          defaultValue={refCategory.toString()}
                        >
                          <option value={0}>- Category -</option>
                          {loadCategories()}
                        </select>
                      </div>
                    </SelectsSection>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "35px",
                      paddingTop: "20px",
                    }}
                  >
                    <TooltipCheckSection>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tooltipInformationCheck}
                            onChange={(e) => {
                              changeTooltipInformationCheck(e.target.checked);
                            }}
                            name="tooltip-info-check"
                          />
                        }
                        label="Add information tooltip to question"
                      />
                    </TooltipCheckSection>
                  </Grid>
                </Grid>
                {tooltipInformationCheck && (
                  <Grid
                    container
                    style={{ display: "flex", alignContent: "flex-end" }}
                  >
                    <Grid item xs={12} sm={3}>
                      <></>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TooltipDescriptionContainer>
                        <textarea
                          style={{ height: "80px", resize: "none" }}
                          onChange={(e) => handleTextAreaText(e.target.value)}
                          type="text"
                          placeholder="Type text here..."
                          id="tooltipDescription"
                          defaultValue={tooltipDescriptionText}
                        ></textarea>
                      </TooltipDescriptionContainer>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </UpperWrapper>
        </EditSection>
      ) : null}

      {editable ? (
        <>
          <label className="selection-label">Selection</label>
          <div className="row row-border-second scale-section">
            <div className="col-3">
              <Form.Group>
                <Form.Label>Select Scale</Form.Label>
                <Form.Select
                  // as="select"
                  defaultValue={refCantImage}
                  onChange={(e) =>
                    handSectionSubpanel(e.target.value, colorPicker)
                  }
                >
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                  <option value={6}>6</option>
                  <option value={7}>7</option>
                  <option value={8}>8</option>
                  <option value={9}>9</option>
                  <option value={10}>10</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group>
                <Form.Label>Shape</Form.Label>
                <Form.Select
                  // as="select"
                  value={selectImage}
                  onChange={(e) => handleChoiseIcon(e)}
                >
                  <option value="star">Star</option>
                  <option value="heart">Heart</option>
                  <option value="numbers">Numbers</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div style={{ width: "fit-content" }}>
              {selectImage !== "numbers" ? (
                <ColorPicker>
                  <input
                    type="color"
                    className="color-picker-input"
                    defaultValue={colorPicker}
                    onChange={(e) => handleColorPicker(e)}
                  />
                </ColorPicker>
              ) : null}
            </div>
            <div className="col-2">
              <IconSelectedContainer>
                {chooiseSelectImage()}
              </IconSelectedContainer>
            </div>
          </div>
        </>
      ) : null}

      <div className="row">
        <br></br>
        <div>
          <LowerWrapper>
            <ContainerTitle
              style={
                configQuestionStyle.customStyle
                  ? configQuestionStyle.question
                  : stateQuestionsReducer.globalStyle.questions
              }
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {title}
                {tooltipInformationCheck && tooltipDescriptionText !== "" && (
                  <Tooltip
                    placement="left"
                    open={showTooltipDescription}
                    title={
                      <>
                        <Box
                          style={{
                            margin: "0",
                            listStyleType: "circle",
                            lineHeight: "1.3",
                            fontSize: "13px",
                          }}
                        >
                          <span>{tooltipDescriptionText}</span>
                        </Box>
                      </>
                    }
                    arrow
                  >
                    <IconButton
                      onClick={() => {
                        setShowTooltipDescription(!showTooltipDescription);
                      }}
                    >
                      <InfoIcon
                        fontSize="small"
                        style={{
                          cursor: "pointer",
                          color: themeConfig.text.primary,
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </ContainerTitle>
          </LowerWrapper>
        </div>
      </div>
      <div className="row img-rating-container">
        <div className="col-12">
          <ContainerIteration
            colorBackground={
              configQuestionStyle.customStyle
                ? configQuestionStyle.background
                : colorBackground
            }
          >
            {imagePreview.map((i) => i)}
          </ContainerIteration>
        </div>
      </div>
      {!editable && idQuestionSurvey && !globalProps?.questionBank && (
        <div className="overlay-option">
          <div className="bottom-buttons">
            <CloneButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => {
                if (identity !== "form") {
                  saveQuestionBank(true);
                } else {
                  saveFormQuestion(true);
                }
              }}
            >
              <CloneIcon />
              Clone
            </CloneButton>
            {identity !== "form" && (
              <SaveToBank
                hidden={globalProps.disableButton}
                className="w-25 mt-2 mb-3"
                onClick={() => handleSaveToBank()}
              >
                Save to bank
              </SaveToBank>
            )}
            <DeleteButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              Delete
            </DeleteButton>
            <EditButton
              hidden={globalProps.disableButton}
              className="w-25 mt-2 mb-3"
              onClick={() => handleEdit()}
            >
              Edit
            </EditButton>
          </div>
        </div>
      )}
      {editable && (
        <ContainerButtons>
          <div className="left-container">
            <StyledButtonGenericQuestion
              onClick={() => {
                setshowStyleEdit(true);
              }}
            >
              <StyleQuestion />
              Style
            </StyledButtonGenericQuestion>
            {editable && idQuestionSurvey ? (
              <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                <CancelQuestion />
                Cancel
              </StyledButtonGenericQuestion>
            ) : null}
            <StyledButtonGenericQuestion
              lastElement={true}
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              <DeleteQuestion />
              Delete
            </StyledButtonGenericQuestion>
          </div>
          <div className="right-container">
            <StyledButton
              onClick={() => {
                if (identity !== "form") {
                  saveQuestionBank(false);
                } else {
                  saveFormQuestion(false);
                }
              }}
            >
              Save
            </StyledButton>
          </div>
        </ContainerButtons>
      )}
      {showStyleEdit && (
        <StyleQuestionContainer
          hideAnswerStyle
          setshowStyleEdit={setshowStyleEdit}
          stateObject={configQuestionStyle}
          setstateObject={setconfigQuestionStyle}
        ></StyleQuestionContainer>
      )}
      {openMessageYesNoModal && (
        <MessageYesNo
          setOpenMessageYesNoModal={setOpenMessageYesNoModal}
          message="Are you sure you want to delete this question?"
          setResponse={setResponse}
        ></MessageYesNo>
      )}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={refCategory}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </GeneralStyle>
  );
};
export default ImageRatingBox;
